

<app-client-list *ngIf="!EditData" (EventToEdit)="dataEmitfromChild($event)" [DataFromList]="EditOptions"></app-client-list>

<app-client-create-edit *ngIf="EditData" (EventToEdit)="dataEmitfromChild($event)" [DataFromList]="EditOptions"></app-client-create-edit>


